import { StormReportsService, StormReport } from '../../services/stormReports/stormReports';
import { useContext, useEffect, useState } from 'react';
import { Marker } from 'react-leaflet';
import { Icon, LatLngExpression } from 'leaflet';
import loadingContext from '../../context/loadingContext';
import Modal from '../modal/Modal';
import './StormReports.css';
import StormReportsContent from './StormReportsContent';

const service = new StormReportsService();
const createIcon = ({ iconUrl, iconAnchor }: { iconUrl: string, iconAnchor: any }) => {
    return new Icon({
        iconUrl,
        iconAnchor,
        popupAnchor: [0, -20],
        className: 'storm-report-icon'
    });
}

export const StormReports = () => {
    const [reports, setReports] = useState<any[]>([]);
    const [currentReport, setCurrentReport] = useState<any>();
    const [isModalWindowOpen, setIsModalWindowOpen] = useState(false);
    const setLoading = useContext(loadingContext);

    const handleMarkerClick = (report: StormReport) => {
        setCurrentReport(report);
        setIsModalWindowOpen(true);
    };

    const init = async () => {
        setLoading(true);
        const stormReports: StormReport[] = await service.getStormReports();
        setReports(stormReports);
        setLoading(false);
    }
    
    useEffect(() => {
        init();
    }, []);

    const handleModalClose = () => {
        setIsModalWindowOpen(false);
        setCurrentReport(null);
    };

    return (
        <>

            {isModalWindowOpen && (
                <Modal
                    title={"STORM REPORT"}
                    isOpen={isModalWindowOpen}
                    onClose={handleModalClose}
                    size='small'
                >
                    <StormReportsContent 
                        report={currentReport}
                    />
                </Modal>
            )}
            {reports.map((report, index) => {
                    const icon = createIcon({ iconUrl: report.icon.url, iconAnchor: report.icon.anchor });
                    const eventHandlers = {
                        click: () => handleMarkerClick(report),
                        keydown: (e: any) => {
                            if (e.originalEvent.key === 'Enter' || e.originalEvent.keyCode === 13) {
                                handleMarkerClick(report)
                            }
                        }
                    }
                    return (
                        <Marker
                            position={report.position as LatLngExpression}
                            icon={icon}
                            eventHandlers={eventHandlers}
                            keyboard={true}
                            key={index}
                        />
                    );
            })}
        </>
    );
}
